import { useSnackbar, VariantType, WithSnackbarProps, OptionsObject } from 'notistack';
import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

let useSnackbarRef: WithSnackbarProps;

export const SnackbarUtilsConfigurator: React.FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

let notificationCallbacks: any = {
  success(msg: string, options?: OptionsObject) {
    this.toast(msg, 'success', options);
  },
  warning(msg: string, options?: OptionsObject) {
    this.toast(msg, 'warning', options);
  },
  info(msg: string, options?: OptionsObject) {
    this.toast(msg, 'info', options);
  },
  error(msg: string, options?: OptionsObject) {
    this.toast(msg, 'error', options);
  },
  toast(msg: string, variant: VariantType = 'default', options?: OptionsObject) {
    useSnackbarRef.enqueueSnackbar(msg, {
      variant,
      key: new Date().getTime() + Math.random(),
      autoHideDuration: 10000,
      action: key => (
        <IconButton size='small' color='inherit' onClick={() => useSnackbarRef.closeSnackbar(key)}>
          <CloseIcon />
        </IconButton>
      ),
      ...options,
    });
  },
};

export default notificationCallbacks;
